import type { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

type AccountSource = {
  accounts: AccountInfo[];
  instance: Pick<IPublicClientApplication, 'getActiveAccount'>;
};

export const requiresAccountSelection = ({ accounts, instance }: AccountSource): boolean =>
  instance.getActiveAccount() === null && accounts.length > 1;

const getSelectedAccount = ({ accounts, instance }: AccountSource): AccountInfo | null =>
  instance.getActiveAccount() ?? (accounts.length === 1 ? accounts[0]! : null);

export default getSelectedAccount;
